export default "https://housescan.app.solease.nl/static/media/home_battery_2.5ba8350b.svg";